import { seoContentMap } from "./store";
export const DEFAULT_LANG = 'en'

export const getSeoContent = ({
                                  path = null,
                                  lang = null,
                                  type = null
                              } = {}) => {

    if (!lang && localStorage.getItem('defaultI18n')) {
        lang = localStorage.getItem('defaultI18n')
    } else if (!lang) {
        lang = DEFAULT_LANG
    }

    if (type) {
        return type[lang] ?? type['en'];
    }

    let finalLang = lang;
    if (!seoContentMap[finalLang]) {
        console.warn(`Unsupported language "${lang}", fallback to en.`);
        finalLang = DEFAULT_LANG;
    }

    const pageMatch = path.match(/^\/rodin\/page\/(\d+)$/);
    if (pageMatch) {
        const pageNum = pageMatch[1];

        let basePageInfo = seoContentMap[finalLang]['/rodin/page'];

        if (!basePageInfo) {
            console.warn(`No SEO content found for '/rodin/page' in language "${finalLang}". Using default language content.`);
            basePageInfo = seoContentMap[DEFAULT_LANG]['/rodin/page'];
        }

        if (!basePageInfo) {
            basePageInfo = seoContentMap[DEFAULT_LANG]['/'];
        }

        const pageInfo = { ...basePageInfo };

        pageInfo.title = `${pageInfo.title} - Page ${pageNum}`;

        return pageInfo;
    }

    const searchMatch = path.match(/^\/rodin\/search\/(.+)$/);
    if (searchMatch) {
        let keyword = decodeURIComponent(searchMatch[1]);

        keyword = keyword.replace(/\s+/g, ' ').trim();
        keyword = keyword.replace(/\b\w/g, char => char.toUpperCase());

        let baseSearchInfo = seoContentMap[finalLang]['/rodin/search'];

        if (!baseSearchInfo) {
            console.warn(`No SEO content found for '/rodin/search' in language "${finalLang}". Using default language content.`);
            baseSearchInfo = seoContentMap[DEFAULT_LANG]['/rodin/search'];
        }

        if (!baseSearchInfo) {
            baseSearchInfo = seoContentMap[DEFAULT_LANG]['/'];
        }

        const pageInfo = { ...baseSearchInfo };
        pageInfo.description = `${keyword} 3D. ${pageInfo.description}`;

        // for title control keyword length
        if (keyword.length > 35) {
            keyword = keyword.substring(0, 35) + "...";
        }
        pageInfo.title = `${keyword} ${pageInfo.title}`;

        return pageInfo;
    }

    let content = seoContentMap[finalLang][path];
    if (!content) {
        content = seoContentMap[DEFAULT_LANG][path];
    }

    if (!content) {
        content = seoContentMap[DEFAULT_LANG]['/'];
    }

    return content;
};
